// stores/counter.js
import { defineStore } from 'pinia';
import { cleanUpJSON } from './helpers.js'
import axios from 'axios';
import For from './KQLSelects.js';
const select = For;

const ArrayOfPageUIDsFromPath = function(path = 'home') {
  path = path.replace(/\//, "");
  let pages = !path ? ['home'] : path.split('/');
  let language = 'en';
  if(pages[0] == document.documentElement.lang) language = pages.shift();
  return (pages.length == 0) ? ['home'] : pages;
}

const KQLQueryStringFromArrayOfParentIDs = function(pages = ['home']) {
  let queryString = 'page("'+pages.shift()+'")';
  while (pages.length) {
    queryString = queryString + '.children.find("'+pages.shift()+'")'
  }
  return queryString;
}

//Store
export const useStore = defineStore('kirby', {
  state: () => {
    return {
      loading: 0,
      site: {},
      pages: {},
      page: {},
      children: {},
      api: document.location.origin+"/api/query",
      //api: "/api/query",
    }
  },
  actions: {
    //Load Both Page & Site
    loadPageAndSite(path = 'home', template) {
      this.loading = this.loading+1;
      //Get Query String
      const pages = ArrayOfPageUIDsFromPath(path);
      const queryString = KQLQueryStringFromArrayOfParentIDs(pages);
      //Setup Selects and Query String
      let query = {
        select: {
          site: {
            query: 'site',
            select: select.For.Site,
          },
          //page: {
          //  query: queryString,
          //  select: select.For[template] || select.For.Default
          //},
          //children: {
          //  query: queryString+'.children',
          //  select: select.For.Children
          //},
          pages: {
            query: 'site.children',
            select: select.For.Children
          },
        }
      };
      //Load
      console.log('[KQL] loadPageAndSite →', this.api);
      axios.post(this.api, query).then((response) => {
        this.loading = this.loading-1;
        const r = response?.data?.result || {};
        console.log('[KQL] loadPageAndSite ← site keys=', Object.keys(r.site || {}),
          'blocks len=', r.site?.blocks?.length,
          'pages count=', Array.isArray(r.pages) ? r.pages.length : typeof r.pages);
        this.site = cleanUpJSON(r.site);
        this.pages = cleanUpJSON(r.pages) || [];
       }).catch((err) => {
        this.loading = this.loading-1;
        console.error('[KQL] loadPageAndSite FAILED',
          err?.response?.status, err?.response?.data || err?.message);
       });
    },
    //Load Page
    loadPage(path = 'home', template) {
      this.loading = this.loading+1;
      //Get Query String
      const pages = ArrayOfPageUIDsFromPath(path);
      const queryString = KQLQueryStringFromArrayOfParentIDs(pages);
      //Setup Selects and Query String
      let query = {
        select: {
          page: {
            query: queryString,
            select: select.For[template] || select.For.Default
          },
          //children: {
          //  query: queryString+'.children',
          //  select: select.For.Children
          //}
        }
      }
      //Load
      console.log('[KQL] loadPage →', path, 'template=', template);
      axios.post(this.api, query).then((response) => {
        if(response.data.result.page!=null) {
          this.loading = this.loading-1;
          console.info('[KQL] loadPage ←', path, 'keys=', Object.keys(response.data.result.page || {}));
          this.page = cleanUpJSON(response.data.result.page);
          //this.children = 'pagination' in response.data.result.children ? cleanUpJSON(response.data.result.children.data) : cleanUpJSON(response.data.result.children);
        } else {
          console.error('[KQL] loadPage page=null', query);
          window.location.href = '/error'
        }
      }).catch((err) => {
        console.error('[KQL] loadPage FAILED',
          err?.response?.status, err?.response?.data || err?.message);
      });
    }
  },
})
